import { useCallback, useContext, useMemo, useState } from 'react'
import { Box } from '@mui/material'
import PlaybooksTable from '../../components/features/playbooks/PlaybookTable'
import DashboardToolbar from '../../components/features/playbooks/DashboardToolbar'
import PlaybookCreateModal from '../../components/features/Modals/PlaybookCreateModal'
import { PlaybookContext } from '../../contexts/playbooks.context'
import { usePlaybookSocket } from '../../hooks/usePlaybookSocket'
import { useToast } from '../../contexts/toast.context'
import { IEvent } from '../../types/event.type'
import { getOnePlaybook, importPlaybookYaml } from '../../services/playbook.service'

import styles from './styles.module.scss'

const PlaybooksDashboard = () => {
  const [isOpen, setIsOpen] = useState(false)

  const { playbooks, setPlaybooks, setSearch, setPaginationModel, refreshList } = useContext(PlaybookContext)
  const { showToast } = useToast()

  // Subscribe to socket.io rooms for every playbook on the current page
  // so that status changes (running/stopped) appear in real time.
  const playbookIds = useMemo(() => playbooks.map((pb) => pb.id), [playbooks])

  const handleEvent = useCallback(
    async (ev: IEvent) => {
      console.log('playbooks', ev)
      if (ev.run.status === 'running') {
        setPlaybooks((prev) => prev.map((pb) => (pb.id === ev.playbook.id ? { ...pb, status: 'running' } : pb)))
      } else {
        const resp = await getOnePlaybook(ev.playbook.id.toString())
        if (resp.success && resp.data) {
          setPlaybooks((prev) =>
            prev.map((pb) => (pb.id === ev.playbook.id ? { ...pb, status: resp.data!.status } : pb)),
          )
        }
      }
    },
    [setPlaybooks],
  )

  usePlaybookSocket(playbookIds, handleEvent)

  const handleImport = useCallback(
    (file: File) => {
      const reader = new FileReader()
      reader.onload = async (e) => {
        const yaml = e.target?.result as string
        const resp = await importPlaybookYaml(yaml)
        if (resp.success) {
          showToast('success', resp.message || 'Playbook imported successfully')
          refreshList()
        }
      }
      reader.readAsText(file)
    },
    [showToast, refreshList],
  )

  const handleSearch = (search: string) => {
    setSearch(search)
    setPaginationModel((prev) => ({
      ...prev,
      page: 0,
    }))
  }

  return (
    <Box className={`${styles.dashboard} main-container`}>
      <DashboardToolbar onSearch={handleSearch} onRefresh={refreshList} onImport={handleImport} setIsOpen={setIsOpen} />
      <PlaybooksTable />
      <PlaybookCreateModal open={isOpen} onClose={() => setIsOpen(false)} />
    </Box>
  )
}

export default PlaybooksDashboard
